
<template>
  <v-layout row>
    <v-dialog v-model="comment.dialog"
              :persistent="comment.subscription"
              max-width="900px">
        <v-card>
          <v-card-title class="title blue-title pa-3 pt-4 ml-2">
            Leave Remarks
            <v-tooltip bottom class="pr-2" content-class="common-tooltip">
              <template v-slot:activator="{ on }">
                  <i class="material-icons ml-2" style="color:#F69898" v-on="on">report_problem</i>
              </template>
              <span>Notice:<br/>
                  1.&nbsp;This is not a test, so NO POINTS will be deducted based on your feedback<br/>
                  2.&nbsp;This survey is completely confidential. Please be frank to write your constructive suggestions, and we will appreciate your input onto the Acadsoc's traine(s)' performance<br>
                  3.&nbsp;Should you have any questions or concerns, please don't hesitate to contact: bellaxie@acadsoc.com(TM1) Libbyli@acadsoc.com(TM2)<br>
                  4.&nbsp;Please respond to each item by light up the star which best describes your opinion<br>
                  A. Strongly Agree B. Agree C. Neutral D. Disagree E. Strongly Disagree
              </span>
          </v-tooltip>
          <span class="font-weight-regular ml-3" :style="{'color':notChoose?'#EE344C':'rgba(50, 57, 122, 0.4)','font-size':'14px'}">Please light up the star to evaluate.</span>
          <div v-if="!comment.subscription" class="header-close" title="close" @click="comment.dialog = false">
            <v-icon>close</v-icon>
          </div>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container grid-list-md px-2 py-0>
              <v-layout wrap>
                <v-flex xs12 class="pink-normal">
                  {{comment.courseType}} trained by {{comment.trainer}} ({{comment.time}})
                </v-flex>
                <v-flex xs12 mt-5> 
                  <v-stepper v-model="e1" class="common-stepper-vertical">
                    <v-layout row>
                    <v-flex xs2>
                      <v-stepper-header>
                        <v-flex xs12>
                          <v-stepper-step :complete="e1 > 1" step="1">Content</v-stepper-step><span class="subject-count" :style="{'color':form1.length<5 && notChoose?'#EE344C':'#32397A'}">{{Object.keys(form1).length}}/5</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider vertical></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <v-stepper-step :complete="e1 > 2" step="2">Attitude</v-stepper-step><span class="subject-count" :style="{'color':form2.length<5 && e1==2 && notChoose?'#EE344C':'#32397A'}">{{Object.keys(form2).length}}/5</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider vertical></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <v-stepper-step :complete="e1 > 3" step="3">Engagement</v-stepper-step><span class="subject-count" :style="{'color':form3.length<5 && e1==3 && notChoose?'#EE344C':'#32397A'}">{{Object.keys(form3).length}}/5</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider vertical></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <v-stepper-step :complete="e1 > 4" step="4">Effectiveness</v-stepper-step><span class="subject-count" :style="{'color':form4.length<5 && e1==4 && notChoose?'#EE344C':'#32397A'}">{{Object.keys(form4).length}}/5</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider vertical></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <v-stepper-step :complete="e1 > 5" step="5">Suggestion</v-stepper-step><span class="subject-count">{{Object.values(this.form5).length}}/3</span>
                        </v-flex>
                      </v-stepper-header>
                    </v-flex>
                    <v-flex xs10>
                      <v-stepper-items>
                        <v-stepper-content v-for="(item,m) in subject" :key="m" :step="m+1" class="py-2 mt-1 pl-3 pr-0">
                          <div class="blue-title">
                            <p class="d-flex justify-content-between mb-4 pb-2" v-for="(value,n) in item.title" :key="n">
                              <span>{{value}}</span>
                              <span class="score-star">
                                <v-icon v-for="i in 5" :key="'tab_1_'+i" :color="answers['tab_'+(m+1)+'_'+(m*5+n)]>(i-1)?'#FFE074':'#e0e0e099'" @click="formFun(m,n,i)">star</v-icon><br>
                                <span>{{answers['tab_'+(m+1)+'_'+(m*5+n)]==1?'Strongly Disagree':answers['tab_'+(m+1)+'_'+(m*5+n)]==2?'Disagree':answers['tab_'+(m+1)+'_'+(m*5+n)]==3?'Neutral':answers['tab_'+(m+1)+'_'+(m*5+n)]==4?'Agree':answers['tab_'+(m+1)+'_'+(m*5+n)]==5?'Strongly Agree':''}}</span>
                              </span>
                            </p>
                          </div>
                        </v-stepper-content>

                        <v-stepper-content step="5" class="py-2 mt-1 pl-3 pr-0">
                          <div class="blue-title">
                            <v-form ref="forms">
                              <p>
                                1. Which part of the course did you enjoy most? Which section of the training is most helpful to you? Why?
                              </p>
                              <v-text-field v-model="form5.enjoyMost" :rules="rules" @input="$v.form5.enjoyMost.$touch()" single-line outline box class="body-2 mb-3" :error-messages="$v.form5.enjoyMost.$error ? 'Required': ''" ></v-text-field>
                              <p>
                                2. Which part of the course did you enjoy least?  Why?
                              </p>
                              <v-text-field v-model="form5.enjoyLeast" :rules="rules" @input="$v.form5.enjoyLeast.$touch()" single-line outline box class="body-2 mb-3" :error-messages="$v.form5.enjoyLeast.$error ? 'Required': ''"></v-text-field>
                              <p>
                                3. Please briefly write any suggestions or recommendations for improvements or additions to the training course/trainer.
                              </p>
                              <v-text-field v-model="form5.suggestions" :rules="rules" @input="$v.form5.suggestions.$touch()" single-line outline box class="body-2 mb-3 pb-1" :error-messages="$v.form5.suggestions.$error ? 'Required': ''" ></v-text-field>
                            </v-form>
                          </div>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-flex>
                  </v-layout>
                    
                  </v-stepper>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center class="pb-4">
              <v-btn class="text-none red-border-button mr-3" v-if="e1>1"
                  @click="lastStep">Last</v-btn>
              <v-btn class="text-none red-button dialog-submit"
                    @click="nextStep" :loading="form5Loading">{{e1==5?'Submit':'Next'}}</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { trainingEvaluation } from '@/api/trainning'
import vmodel from "@/mixins/v-model";
import { validationMixin } from "vuelidate";
import {
    required
} from "vuelidate/lib/validators";
export default {
  name: 'comment',
  props: {
    comment: {
      dialog: false,
      id: 0,
      courseType:'',
      trainer:'',
      time:'',
      subscription:false
    }
  },
  data: () => ({
    e1:1,
    form5:{},
    form5Loading:false,
    notChoose:false,
    rules: [
      v => !!v || 'Required',
      v => (v&&v.length <= 512) || 'Max 512 characters'
    ],
    subject:[
      {
        title:[
          "1. The training objectives were clearly stated at the beginning.",
          "2. I feel the training content was well-organized and easy to follow.",
          "3. There was a balance between theoretical and practical elements of the training.",
          "4. The relevant cases/examples/live situations discussed in the training were helpful for my comprehension and real teaching applications.",
          "5. I feel the exercises and activities incorporated in the training enhanced my understanding of the target knowledge being discussed and illustrated."
        ]
      },
      {
        title:[
          "1. The trainer was open, honest, and fair to all (me).",
          "2. The trainer was patient, polite, and provided support in a caring manner.",
          "3. The trainer was punctual.",
          "4. The trainer was well prepared for the training, structrued the training session well and managed the time effectively.",
          "5. The trainer showed passion and professionalism throughout the whole training session."
        ]
      },
      {
        title:[
          "1. I feel the training contents and activites are interesting.",
          "2. I feel the length of the training is acceptable.",
          "3. I feel the way of participating in this training is acceptable.",
          "4. The multimedia components (e.g., video, audio, image, PPT) in this training are appealing to me.",
          "5. The interaction with the instructor (facilitator) and my peers was helpful for the training process."
        ]
      },
      {
        title:[
          "1. I feel the training contents are helpful for my teaching.",
          "2. I feel the training has improved my teaching skills.",
          "3. The assigned training materials (e.g., templates or videos) were useful and helped me understand the content.",
          "4. The training assessment was helpful to reflect my learning outcomes.",
          "5. The training gave me confidence to perform better in my online EFL（English as a Foreign Language） classes."
        ]
      }
    ],
    form:{},
    form1:[],
    form2:[],
    form3:[],
    form4:[],
    answers:{},
    answerArr:[]
  }),
  mixins: [vmodel, validationMixin],
  validations() {
      return {
          form5: {
              enjoyMost: { required },
              enjoyLeast:{ required },
              suggestions:{ required }
          }
      };
  },
  methods: {
    lastStep(){
      if(this.e1>1) this.e1--
    },
    nextStep(){
      this.notChoose = false;
      if(this.e1==1){
        if(this.form1.length==5) this.e1++;
        else this.notChoose = true;
      }else if(this.e1==2){
        if(this.form2.length==5) this.e1++;
        else this.notChoose = true;
      }else if(this.e1==3){
        if(this.form3.length==5) this.e1++;
        else this.notChoose = true;
      }else if(this.e1==4){
        if(this.form4.length==5) this.e1++;
        else this.notChoose = true;
      }else {
          this.$refs.forms.resetValidation()
          this.submit()
      }
    },
    submit(){
      this.$v.form5.$touch();
      if (this.$v.form5.$invalid) {
          console.log("form5-error");
          this.form5Loading = false;
          return;
      }
      this.form5Loading = true;
      var answer = Object.keys(this.form).map((item,i)=>{
        return {questionId:i+1,answer:this.answers['tab_'+(parseInt(i/5)+1)+'_'+i]}
      })
      answer.push({questionId:21,answer:this.form5.enjoyMost},{questionId:22,answer:this.form5.enjoyLeast},{questionId:23,answer:this.form5.suggestions})
      trainingEvaluation(this.comment.id,answer).then(res=>{
        if(res.data.Body){
          var type =  res.data.Body.Item1==1?'success':'error'
            this.$root.$alertTips(res.data.Body.Item2,type).then(()=>{
              this.comment.dialog = false
              if(this.comment.subscription) this.$emit('customfunc')
              else this.$emit('func')
            });
        }
      }).finally(()=>{
        this.form5Loading = false;
      })
    },
    formFun(m,n,i){
      this.form['tab_'+(m+1)+'_'+(m*5+n)]=i;
      this.answers = Object.assign({},this.form);
      this.form1=[];
      this.form2=[];
      this.form3=[];
      this.form4=[];
       for(let key in this.answers){
          if(key.startsWith("tab_1")) this.form1.push(this.answers[key]);
          else if(key.startsWith("tab_2")) this.form2.push(this.answers[key]);
          else if(key.startsWith("tab_3")) this.form3.push(this.answers[key]);
          else this.form4.push(this.answers[key]);
      }
    }
  },
  watch:{
    form1:function(value){
      if(value.length>4){
        this.e1=2
      }
    },
    form2:function(value){
      if(value.length>4){
        this.e1=3
      }
    },
    form3:function(value){
      if(value.length>4){
        this.e1=4
      }
    },
    form4:function(value){
      if(value.length>4){
        this.e1=5
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.score-star{
  display:inline-block;
  max-width: 125px;
  min-width: 125px;
  text-align:left;
  margin-left:30px;
  height:47px;
  span{
    color:rgba(50, 57, 122, 0.8)
  }
}
.common-tooltip{
  width:550px;
  margin-left:120px;
  &:after {
    left: 27%;
  }
}
.blue-title{
  @include font_color($font-color-theme);
}
</style>
